import{classCallCheck as l}from"../../_virtual/_rollupPluginBabelHelpers.js";var r=function r(){l(this,r)};export{r as AbstractLayoutAdapter};
